module.exports = __webpack_public_path__ + "media/images/views/lp/recruiter/steps/rc-step02-f35a033248613b79917f417c4e5c3197.png";